import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updatePlan } from 'api/auth.api';

export const useUpdatePlan = ({ onSuccess } = {}) => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePlan,

    onSuccess: (res) => {
      toast({
        title: 'Plan updated successfully',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      // Refetch plans list
      queryClient.invalidateQueries(['plans-list']);

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update plan',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
